import { Constants } from '../_constants/shared.constants';
export const  success=(data)=> {
     return{ type: Constants.login.LOGIN_SUCCESS,data }
     }
export const  error=(data)=> { 
    return{ type: Constants.login.LOGIN_FAILURE,data }
 }
  